/* Kolab size guide.
   Progressive enhancement over the markup in the "size-guide" page: with JS off the
   page still reads as a chart. Strings come from #kz-i18n, which Liquid renders in
   the visitor's language only. */
(function () {
  if (window.__kolabSizeGuide) return;
  window.__kolabSizeGuide = true;

  var D = null;
  try {
    var tag = document.getElementById('kz-i18n');
    if (tag) D = JSON.parse(tag.textContent);
  } catch (e) { /* fall through to the English already in the markup */ }

  function t(key, fallback) { return (D && D[key]) || fallback; }

  function translate(root) {
    if (!D) return;
    root.querySelectorAll('[data-i18n]').forEach(function (el) {
      var v = D[el.getAttribute('data-i18n')];
      if (v != null) el.innerHTML = v;
    });
    if (D.b) {
      root.querySelectorAll('[data-bk]').forEach(function (li) {
        var v = D.b[li.getAttribute('data-bk')];
        var slot = li.querySelector('[data-bt]');
        if (v && slot) slot.textContent = v;
      });
    }
  }

  /* What the product page this was opened from is actually selling */
  function productSizes() {
    var info = document.querySelector('product-info');
    if (!info) return null;
    var out = [], seen = {};
    info.querySelectorAll('input[type="radio"]').forEach(function (i) {
      var v = (i.value || '').trim();
      if (!v || seen[v]) return;
      seen[v] = 1;
      out.push({ value: v, sold: i.disabled || i.classList.contains('disabled') });
    });
    return out.length ? out : null;
  }

  function init(root) {
    translate(root);
    if (root.closest('coretex-dialog')) root.setAttribute('data-compact', '');

    var tabs = [].slice.call(root.querySelectorAll('[data-kz-tab]'));
    var panels = {};
    root.querySelectorAll('[data-kz-panel]').forEach(function (p) { panels[p.getAttribute('data-kz-panel')] = p; });
    function show(name) {
      tabs.forEach(function (b) {
        var on = b.getAttribute('data-kz-tab') === name;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });
      Object.keys(panels).forEach(function (k) { panels[k].hidden = k !== name; });
    }
    tabs.forEach(function (b, i) {
      b.addEventListener('click', function () { show(b.getAttribute('data-kz-tab')); });
      b.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var n = tabs[(i + d + tabs.length) % tabs.length];
        n.focus(); show(n.getAttribute('data-kz-tab'));
      });
    });

    var rows = [].slice.call(root.querySelectorAll('[data-kz-table="shoes"] tbody tr'));
    var lens = rows.map(function (r) { return parseFloat(r.getAttribute('data-cm')); });
    var input = root.querySelector('[data-kz-cm]');
    var out = root.querySelector('[data-kz-out]');
    var unit = 'cm';
    var toCm = function (v) { return unit === 'cm' ? v : v * 2.54; };

    function render() {
      if (!input || !out) return;
      var val = parseFloat(input.value);
      if (isNaN(val)) return;
      var cm = toCm(val);
      rows.forEach(function (r) { r.removeAttribute('data-hit'); });

      var lo = Math.min.apply(null, lens), hi = Math.max.apply(null, lens);
      if (cm < lo - 0.4 || cm > hi + 0.4) {
        out.innerHTML = '<span class="kz-miss">' +
          t('result_none', 'Outside the chart. Message us and we will help.') + '</span>';
        return;
      }
      /* Nearest length rather than an exact hit, so inches and odd decimals land
         somewhere. EU numbering is not linear, so one length can share two sizes. */
      var best = Infinity;
      lens.forEach(function (l) { best = Math.min(best, Math.abs(l - cm)); });
      var hits = rows.filter(function (r, i) { return Math.abs(lens[i] - cm) - best < 0.01; });

      hits.forEach(function (r) { r.setAttribute('data-hit', ''); });
      var eu = hits.map(function (r) { return r.getAttribute('data-eu'); }).join('–');
      var c = hits[0].cells;
      var eq = 'UK ' + c[1].textContent + ' · US ' + c[2].textContent + ' · ' + c[3].textContent + ' cm';

      var stock = '';
      if (hits.some(function (r) { return r.hasAttribute('data-have'); })) {
        stock = '<span class="kz-stock">' + t('in_stock', 'In stock') + '</span>';
      } else if (hits.some(function (r) { return r.hasAttribute('data-gone'); })) {
        stock = '<span class="kz-stock" data-out>' + t('sold', 'Sold out') + '</span>';
      }

      out.innerHTML =
        '<span class="kz-card"><span class="kz-card-eu"><small>EU</small>' + eu + '</span>' +
        '<span class="kz-card-eq">' + eq + '</span></span>' + stock;

      var box = hits[0].closest('.kz-twrap');
      if (box && box.scrollHeight > box.clientHeight) {
        box.scrollTop = Math.max(0, hits[0].offsetTop - (box.clientHeight - hits[0].offsetHeight) / 2);
      }
    }

    if (input) {
      input.addEventListener('input', render);
      root.querySelectorAll('[data-kz-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = unit === 'cm' ? 0.5 : 0.25;
          var v = parseFloat(input.value) || 0;
          input.value = String(+(v + step * parseFloat(b.getAttribute('data-kz-step'))).toFixed(2));
          render();
        });
      });
      root.querySelectorAll('[data-kz-unit]').forEach(function (b) {
        b.addEventListener('click', function () {
          var next = b.getAttribute('data-kz-unit');
          if (next === unit) return;
          var cm = toCm(parseFloat(input.value) || 26);
          unit = next;
          root.querySelectorAll('[data-kz-unit]').forEach(function (o) {
            o.setAttribute('aria-pressed', o.getAttribute('data-kz-unit') === unit ? 'true' : 'false');
          });
          input.value = String(+(unit === 'cm' ? cm : cm / 2.54).toFixed(2));
          input.step = unit === 'cm' ? '0.5' : '0.25';
          render();
        });
      });
    }

    /* Mark what this product has, and lift its brand note to the top */
    var sizes = productSizes();
    var ctx = root.querySelector('[data-kz-ctx]');
    var numeric = false, mine = null;

    if (sizes) {
      var by = {};
      sizes.forEach(function (s) { by[s.value.replace(',', '.').toUpperCase()] = s; });
      numeric = sizes.some(function (s) { return /^\d/.test(s.value); });
      rows.forEach(function (r) {
        var s = by[r.getAttribute('data-eu')];
        if (s) r.setAttribute(s.sold ? 'data-gone' : 'data-have', '');
      });
      root.querySelectorAll('[data-kz-table="clothing"] tbody tr').forEach(function (r) {
        var s = by[(r.getAttribute('data-size') || '').toUpperCase()];
        if (s) r.setAttribute(s.sold ? 'data-gone' : 'data-have', '');
      });
    }

    var brandEl = document.querySelector('.kolab-brand');
    if (brandEl) {
      var key = brandEl.textContent.trim().toLowerCase().replace(/[^a-z0-9]/g, '');
      root.querySelectorAll('[data-brand]').forEach(function (li) {
        if (li.getAttribute('data-brand').split('|').indexOf(key) > -1) mine = li;
      });
    }

    if (ctx && (sizes || mine)) {
      var html = '<p class="kz-ctx-h">' + t('ctx_h', 'This product') + '</p>';
      if (mine) html += '<div class="kz-ctx-note">' + mine.innerHTML + '</div>';
      if (sizes) {
        html += '<div class="kz-chips">' + sizes.map(function (s) {
          return '<span class="kz-chip"' + (s.sold ? ' data-out' : '') + '>' + s.value + '</span>';
        }).join('') + '</div>';
      }
      ctx.innerHTML = html;
      ctx.hidden = false;
    }

    if (sizes) show(numeric ? 'shoes' : 'clothing');
    render();

    /* Nothing lays out while the sheet is closed, so recompute when it opens */
    var host = root.closest('coretex-dialog');
    var sheet = host && host.querySelector('dialog');
    if (sheet) {
      new MutationObserver(function () {
        if (sheet.hasAttribute('open')) setTimeout(render, 60);
      }).observe(sheet, { attributes: true, attributeFilter: ['open'] });
    }
  }

  /* The "Size guide" link in the Fit & sizing accordion opens the sheet, which knows
     the product, rather than navigating away from it. */
  function wireOpeners() {
    var trigger = document.querySelector('[data-open*="sizechart"]');
    if (!trigger) return;
    document.querySelectorAll('[data-kolab-sizeguide-open]').forEach(function (a) {
      if (a.__kzWired) return;
      a.__kzWired = true;
      a.addEventListener('click', function (e) { e.preventDefault(); trigger.click(); });
    });
  }

  function boot() {
    document.querySelectorAll('[data-kolab-sizeguide]').forEach(function (root) {
      if (root.__kzDone) return;
      root.__kzDone = true;
      try { init(root); } catch (e) { /* the static markup still reads fine */ }
    });
    wireOpeners();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
